// const server = "http://localhost";
// const port = 9162;
// const domain = "localhost";
const server = "https://apiv2amairca.mansolutions.app";
const port = 443;
const domain = "admin.amairca.mansolutions.net";
export { server, port, domain };
